export var FlakePrefixes;
(function (FlakePrefixes) {
    FlakePrefixes["Path"] = "p";
    FlakePrefixes["List"] = "li";
    FlakePrefixes["ListRow"] = "lr";
    FlakePrefixes["ListProperty"] = "lp";
    FlakePrefixes["ListCell"] = "lc";
})(FlakePrefixes || (FlakePrefixes = {}));
